// extracted by mini-css-extract-plugin
export default {"number":"QuestionNumber_number__EPB7h","number-text":"QuestionNumber_number-text__GOjyy","done":"QuestionNumber_done__zrhO0"};